import type { LoginCodeChannel } from "src/features/users/services/requestLoginCode";

export type LoginHandoff =
  | {
      identifier: string;
      codeSent: false;
    }
  | {
      identifier: string;
      codeSent: true;
      channel: LoginCodeChannel;
    };

type LoginHandoffState = {
  loginHandoff: LoginHandoff;
};

/**
 * Keep login identifiers out of the URL while carrying a duplicate-signup
 * handoff into the appropriate login step.
 */
export function createLoginHandoffState(
  identifier: string,
  channel?: LoginCodeChannel
): LoginHandoffState {
  return {
    loginHandoff: channel
      ? { identifier, codeSent: true, channel }
      : { identifier, codeSent: false },
  };
}

/** Treat router state as untrusted: it can be restored or supplied externally. */
export function getLoginHandoff(state: unknown): LoginHandoff | undefined {
  if (typeof state !== "object" || state === null) return undefined;

  const { loginHandoff } = state as { loginHandoff?: unknown };
  if (typeof loginHandoff !== "object" || loginHandoff === null) {
    return undefined;
  }

  const candidate = loginHandoff as {
    identifier?: unknown;
    codeSent?: unknown;
    channel?: unknown;
  };
  if (
    typeof candidate.identifier !== "string" ||
    !candidate.identifier.trim()
  ) {
    return undefined;
  }

  if (candidate.codeSent === false) {
    return { identifier: candidate.identifier, codeSent: false };
  }
  if (
    candidate.codeSent === true &&
    (candidate.channel === "sms" || candidate.channel === "email")
  ) {
    return {
      identifier: candidate.identifier,
      codeSent: true,
      channel: candidate.channel,
    };
  }
  return undefined;
}
